import { IChartConfig } from './AdminDashboard.types';

export const getChartsConfigs = (
  startDate: string,
  endDate: string,
): IChartConfig => ({
  sessions: {
    chart: {
      options: {
        title: 'Sessions',
        width: '100%',
      },
      type: 'LINE',
    },
    query: {
      dimensions: 'ga:date',
      'end-date': endDate,
      metrics: 'ga:sessions',
      'start-date': startDate,
    },
    reportType: 'ga',
  },

  uniquePageviews: {
    chart: {
      type: 'LINE',
    },
    query: {
      dimensions: 'ga:date',
      'end-date': endDate,
      metrics: 'ga:uniquePageviews',
      'start-date': startDate,
    },
    reportType: 'ga',
  },

  avgSessionDuration: {
    chart: {
      options: {
        title: 'Avg. Session Duration (sec)',
        width: '100%',
      },
      type: 'LINE',
    },
    query: {
      dimensions: 'ga:date',
      'end-date': endDate,
      metrics: 'ga:avgSessionDuration',
      'start-date': startDate,
    },
    reportType: 'ga',
  },

  newUsers: {
    chart: {
      options: {
        title: 'New vs. Returning Visitors',
        width: '100%',
      },
      type: 'LINE',
    },
    query: {
      dimensions: 'ga:date',
      'end-date': endDate,
      metrics: 'ga:users,ga:newUsers',
      'start-date': startDate,
    },
    reportType: 'ga',
  },

  country: {
    chart: {
      options: {
        title: 'New vs. Returning Visitors',
        width: '100%',
      },
      type: 'TABLE',
    },
    query: {
      dimensions: 'ga:country',
      'end-date': endDate,
      metrics: 'ga:users',
      'start-date': startDate,
    },
    reportType: 'ga',
  },
  urls: {
    chart: {
      options: {
        pieHole: 4 / 9,
        title: 'Top 10 pages',
        width: '100%',
      },
      type: 'PIE',
    },
    query: {
      dimensions: 'ga:pagePathLevel1',
      'end-date': endDate,
      filters: 'ga:pagePathLevel1!=/',

      'max-results': 10,
      metrics: 'ga:pageviews',
      sort: '-ga:pageviews',
      'start-date': startDate,
    },
    reportType: 'ga',
  },
});
